interface AllProps {
  location?: string;
  service?: string;
  meetingMethod?: string | number;
  language?: string;
  includeWaitTime?: boolean;
}

const LobbyAvailability = (client) => ({
  all({
    location,
    service,
    meetingMethod,
    language,
    includeWaitTime,
  }: AllProps) {
    const params: Record<string, any> = {};

    if (location) {
      params.location = parseInt(location, 10);
    }

    if (service) {
      params.service = parseInt(service, 10);
    }

    if (meetingMethod) {
      params.meeting_method = meetingMethod;
    }

    if (language) {
      params.language = language;
    }

    if (includeWaitTime) {
      params.include_wait_time = includeWaitTime;
    }

    const query = Object.keys(params)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
      )
      .join('&');

    return client.get(
      `/api/v3/open/lobby-availability${query ? `?${query}` : ''}`,
    );
  },
});

export default LobbyAvailability;
